const filters = {
  btnFilters: 'מסננים',
  titleDropdown: 'מסננים מהירים',

  filterDate: {
    today: 'היום',
    tomorrow: 'מחר',
    yesterday: 'אתמול',
    lastWeek: 'השבוע שעבר',
    lastMonth: 'החודש שעבר',
    customRange: 'טווח מותאם',
    overLimit: 'אנא בחר טווח של {{limit}} ימים או פחות',
    
    fromTime: 'משעה',
    toTime: 'עד שעה',
  },
};

export default filters;
